import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable()
export class ProjectValidationInterceptorService implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the X-Project header from the request
    const requestProjectCode = request.headers.get('X-Project');

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Get the X-Project header from the response
          const responseProjectCode = event.headers.get('X-Project');

          // Only validate if:
          // 1. Request had X-Project header
          // 2. Response has X-Project header
          if (requestProjectCode && responseProjectCode) {
            // Compare in uppercase to avoid case sensitivity issues
            if (requestProjectCode.toUpperCase() !== responseProjectCode.toUpperCase()) {
              console.error('[Project Validation Error]', {
                request: requestProjectCode,
                response: responseProjectCode,
                url: request.url
              });

              // Throw error to prevent displaying the response
              throw new HttpErrorResponse({
                error: {
                  message: 'Project code mismatch detected. The response belongs to a different project.',
                  requestProject: requestProjectCode,
                  responseProject: responseProjectCode
                },
                headers: event.headers,
                status: 400,
                statusText: 'Project Code Mismatch',
                url: request.url
              });
            }
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Pass through the error
        return throwError(() => error);
      })
    );
  }
}

